import { render, staticRenderFns } from "./QueryPrescriptions.vue?vue&type=template&id=42662396&scoped=true&"
import script from "./QueryPrescriptions.vue?vue&type=script&lang=js&"
export * from "./QueryPrescriptions.vue?vue&type=script&lang=js&"
import style0 from "./QueryPrescriptions.vue?vue&type=style&index=0&id=42662396&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42662396",
  null
  
)

export default component.exports